module.exports = __webpack_public_path__ + "static/img/RCV.8bb7f1f4.png";